import React from 'react';

import SubscriptionOptionCard from '@components/SubscriptionOptionCard';
import useEventTracking from '@hooks/useEventTracking';
import { TrackingLocation } from '@tracking';
import { generateCardProps, planType } from '@utils/subscriptionCardOptions';

interface OffersProps {
  offerPlans: planType[];
}

const Offers = ({ offerPlans }: OffersProps) => {
  const offers = offerPlans.map((planType) => generateCardProps({ planType }));
  useEventTracking({ location: TrackingLocation.OfferList });

  return (
    <>
      <h6 className="mb-32 mt-0 text-center font-suisse-screen text-headline-xxs text-grayscale-charcoal md:mb-24">
        More Subscription Options
      </h6>
      <div
        className="m-auto flex max-w-[1010px] flex-col items-center justify-center px-16 sm:px-0 md:flex-row md:items-start"
        data-test="card-section"
      >
        {offers.map((cardProps) => (
          <div
            key={cardProps.title}
            className="w-full max-w-[311px] flex-1 border-0 border-b border-solid border-grayscale-beige py-32 first:pl-0 first:pt-0 last:border-b-0 last:border-r-0 last:pb-0 last:pr-0 xs:w-[311px] md:max-w-none md:border-b-0 md:border-r md:px-48 md:py-0 lg:px-24"
          >
            <SubscriptionOptionCard {...cardProps} />
          </div>
        ))}
      </div>
    </>
  );
};

export default Offers;
